import { useAuth } from '../../context/AuthContext';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const headerStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .lh-header { background:white; border-bottom:1px solid #e8ebf4; padding:12px 24px; display:flex; align-items:center; justify-content:space-between; position:sticky; top:0; z-index:30; font-family:'Sora',sans-serif; }
  .lh-avatar { width:34px; height:34px; border-radius:10px; background:#fffbeb; color:#f59e0b; display:flex; align-items:center; justify-content:center; font-size:.72rem; font-weight:700; flex-shrink:0; }
  .lh-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .lh-logout { padding:7px 14px; background:#fffbeb; color:#f59e0b; border:1px solid #fde68a; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .lh-logout:hover { background:#fef3c7; }
  .lh-menu-btn { display:none; background:none; border:none; cursor:pointer; padding:4px; }
  @media(max-width:768px) {
    .lh-menu-btn { display:flex; }
    .lh-name { display:none; }
    .lh-logout { padding:6px 10px; font-size:.72rem; }
  }
`;

const LibrarianHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Librarian';
  const initials = (n='') => n.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?';
  return (
    <>
      <style>{headerStyle}</style>
      <header className="lh-header">
        <button onClick={onMenuClick} className="lh-menu-btn">
          <Bars3Icon style={{ width:22, height:22, stroke:'#6b7194' }} />
        </button>
        <div style={{ fontSize:'.9rem', fontWeight:700, color:'#0f1123' }}>Library Portal</div>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div className="lh-avatar">{initials(displayName)}</div>
          <div className="lh-name">{displayName}</div>
          <button className="lh-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
};

export default LibrarianHeader;
